<div class="login-content">
  <!-- <div class="block-left">
    <div class="carousel-container">
      <div class="carousel-images">
        <img
          *ngFor="let image of images; let i = index"
          [src]="image"
          [class.active]="i === currentImageIndex"
          alt="Carousel Image"
        />
      </div>
    </div>
    <div class="carousel-dots">
      <span
        *ngFor="let image of images; let i = index"
        [class.active]="i === currentImageIndex"
        (click)="setImage(i)"
      ></span>
    </div>
  </div> -->

  @if (isLogin) {
    <div class="block-right">
      <form [formGroup]="loginForm" (ngSubmit)="submitLoginForm()">
        <img class="logo" src="../../../assets/images/systems/assai/logo.png" />
        <h2>Entrar</h2>
        <div class="container-input" [ngClass]="{ focused: usernameFocused }" style="margin-top: 20px;">
          <label for="username">Usuário</label>
          <i class="material-icons notranslate left-icon">person_outline</i>
          <input
            formControlName="username"
            type="text"
            name="username"
            placeholder="Usuário"
            (focus)="onFocus('username')"
            (blur)="onBlur('username')"
          />
        </div>
        <div class="container-input" [ngClass]="{ focused: passwordFocused }">
          <label for="password">Senha</label>
          <i
            class="material-icons notranslate left-icon"
          >
            {{ showPassword ? 'lock_open' : 'lock_outline' }}
          </i>
          <input
            formControlName="password"
            [type]="showPassword ? 'text' : 'password'"
            name="password"
            placeholder="Senha"
            (focus)="onFocus('password')"
          />
            <i class="material-icons notranslate right-icon" (click)="toggleShowPassword()" >
              {{ showPassword ? 'visibility_off' : 'visibility' }}
            </i>
        </div>

        <a class="forgot-password" (click)="handleForgetPassword()"
          >Esqueci minha senha</a
        >

        <div class="container-button">
          @if(incorrectPassword){
            <div class="warning">
              <i class="material-icons notranslate v-align"> report_problem </i>
              <span>Usuário ou senha incorretos</span>
            </div>
          }
          <button type="submit" class="button red">Entrar</button>
        </div>
      </form>
    </div>
  }

  @if (isForgotPassword) {
    <div class="block-right">
      <form [formGroup]="resetPasswordForm">
        <img class="logo" src="../../../assets/images/systems/assai/logo.png" />
        <h2>Esqueci minha senha</h2>
        <h3>Informe seu e-mail de cadastro para enviarmos o código de redefinição de senha
        </h3>
        <div class="container-input" [ngClass]="{ focused: emailFocused }">
          <label for="email">E-mail</label>
          <i
            class="material-icons notranslate left-icon"
            (click)="toggleShowPassword()"
          >
            mail_outline
          </i>
          <input
            type="email"
            name="email"
            class="form-input"
            placeholder="Digite seu e-mail"
            formControlName="email"
            (focus)="onFocus('email')"
          />
        </div>
        <div class="container-button">
          @if (resetPasswordForm.get('email')?.touched && resetPasswordForm.get('email')?.invalid) {
            <div class="warning">
              <i class="material-icons notranslate v-align"> report_problem </i>
              <span>E-mail Inválido!</span>
            </div>
          }
          <button type="submit" class="button red" (click)="handleClickResetPassword()">
            Enviar
          </button>
          <button
            type="button"
            class="button outline"
            (click)="handleInitialLoginPage()"
          >
            Voltar
          </button>
        </div>
      </form>
    </div>
  }

  @if (isChangePassword) {
    <div class="block-right">
      <form [formGroup]="changePasswordForm" autocomplete="off" novalidate>
        <img class="logo" src="../../../assets/images/systems/assai/logo.png" />
        <h2>Redefinição de senha</h2>
        <h3>Informe a nova senha</h3>
        <div class="container-input" [ngClass]="{ focused: passwordFocused }">
          <label for="password">Nova senha:</label>
          <i
            class="material-icons notranslate left-icon"
          >
            {{ passwordFocused ? 'lock_open' : 'lock_outline' }}
          </i>
            <input
              formControlName="newPassword"
              name="newPassword"
              autocomplete="new-password"
              [type]="showPassword ? 'text' : 'password'"
              placeholder="Nova senha"
              (focus)="onFocus('newPassword')"
              (blur)="onBlur('newPassword')"
            />
           @if(passwordFocused) {
            <i
              class="material-icons notranslate right-icon"
              (click)="toggleShowPassword()"
            >
              {{ showPassword ? 'visibility_off' : 'visibility' }}
            </i>
          }
        </div>
        <div class="container-input" [ngClass]="{ focused: passwordFocusedConfirm }">
          <label for="confirmNewPassword">Confirme a nova senha:</label>
          <i
            class="material-icons notranslate left-icon"
          >
            {{ passwordFocusedConfirm ? 'lock_open' : 'lock_outline' }}
          </i>
            <input
              formControlName="confirmNewPassword"
              name="confirmNewPassword"
              autocomplete="new-password"
              [type]="showPasswordConfirm ? 'text' : 'password'"
              placeholder="Confirme a nova senha"
              (focus)="onFocus('confirmNewPassword')"
              (blur)="onBlur('confirmNewPassword')"
            />
          @if(passwordFocusedConfirm) {
            <i
              class="material-icons notranslate right-icon"
              (click)="toggleShowPasswordConfirm()"
            >
              {{ showPasswordConfirm ? 'visibility_off' : 'visibility' }}
            </i>
          }
        </div>
        @if (changePasswordForm.get('newPassword')?.touched && !changePasswordForm.get('newPassword')?.value && !changePasswordForm.get('confirmNewPassword')?.value && changePasswordForm.get('confirmNewPassword')?.touched) {
          <div class="warning">
            <i class="material-icons notranslate v-align"> report_problem </i>
            <span> É necessário preencher todos os campos.</span>
          </div>
        }
        @if (changePasswordForm.errors?.['passwordsMismatch']) {
          <div class="warning">
            <i class="material-icons notranslate v-align"> report_problem </i>
            <span> As senhas não coincidem.</span>
          </div>
        }
        @if (changePasswordForm.get('newPassword')?.touched && changePasswordForm.get('newPassword')?.errors?.['passwordStrength']) {
          <div class="warning">
            <i class="material-icons notranslate v-align"> report_problem </i>
            <span>A nova senha deve conter no mínimo 8 caracteres, incluindo pelo menos uma letra maiúscula, um número e um caractere especial.</span>
          </div>
        }
        <div class="container-button">
          <button class="button red" type="submit" (click)="handleSubmitChangePassword()">
            Enviar
          </button>
          <button
            type="button"
            class="button outline"
            (click)="handleInitialLoginPage()"
          >
            Voltar
          </button>
        </div>
      </form>
    </div>
  }
</div>
